var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130.853,
    height: 132.412,
    viewBox: "0 0 130.853 132.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 38.427,
    cy: 38.427,
    r: 38.427,
    transform: "translate(39.073 39.073)",
    fill: "#fef8e6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 38.427,
    cy: 38.427,
    r: 38.427,
    transform: "translate(39.073 39.073)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_87cf483ba9a087e581f538dcec97be24",
    "data-name": "87cf483ba9a087e581f538dcec97be24",
    transform: "translate(-12.077 -12.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M62.584,64.443,61.17,63.029q.786-.786,1.574-1.564l1.406,1.422Q63.367,63.661,62.584,64.443Zm4.637-4.553-1.389-1.439q1.554-1.5,3.125-2.978l1.371,1.457Q68.777,58.389,67.221,59.89Zm6.251-5.881L72.12,52.534q1.591-1.458,3.2-2.9l1.334,1.49q-1.6,1.43-3.18,2.882Zm6.4-5.72-1.313-1.508q1.628-1.419,3.276-2.813l1.291,1.527q-1.635,1.387-3.254,2.794Zm6.55-5.541L85.149,41.2q1.668-1.371,3.358-2.716l1.246,1.564q-1.656,1.32-3.334,2.7ZM93.13,37.41l-1.219-1.586q1.74-1.338,3.448-2.6l1.191,1.607Q94.828,36.1,93.13,37.41Zm6.888-5.1-1.16-1.629q1.762-1.256,3.552-2.471l1.123,1.654q-1.771,1.2-3.515,2.446ZM107.1,27.5l-1.084-1.682q1.821-1.174,3.675-2.3l1.035,1.711Q108.9,26.339,107.1,27.5Zm7.313-4.418-.979-1.744c1.3-.731,2.594-1.42,3.833-2.048l.9,1.783q-1.9.966-3.758,2.009Zm7.6-3.832-.807-1.83q2-.888,4.063-1.627l.67,1.885C124.7,18.118,123.376,18.647,122.012,19.249Zm7.939-2.767-.451-1.949a22.391,22.391,0,0,1,4.454-.614l.049,2a20.41,20.41,0,0,0-4.052.563Zm9.347,1.08a4.948,4.948,0,0,0-1.517-1.023l.809-1.83a6.968,6.968,0,0,1,2.122,1.439L139.3,17.562Z",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M102.017,21.7l10.7,7.335L76.2,50.274Z",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M102.453,25.861l1.619,15.23L76.2,50.274Zm-1.426-13.438.99,9.278L76.2,50.274Z",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M112.719,29.036l-10.266-3.175.91,8.618Z",
    fill: "#cccbca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M47.771,45.293l61.938,61.94-2.475,2.475L45.3,47.768Z",
    fill: "#242d3c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 38.427,
    cy: 38.427,
    r: 38.427,
    transform: "translate(39.073 39.073)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M98.053,45.035a38.423,38.423,0,0,1-53.017,53.02,38.425,38.425,0,1,0,53.017-53.02Z",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M86.19,92.8a2.4,2.4,0,0,1,2.4-2.4H77.746a2.4,2.4,0,0,1,0,4.8H88.59a2.4,2.4,0,0,1-2.4-2.4Z",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M90.419,95.195H71.073a2.4,2.4,0,1,0,0,4.8H90.419a2.4,2.4,0,0,0,0-4.8Zm4.94-11.987a2.4,2.4,0,0,1,2.4-2.4H76.02a2.4,2.4,0,1,1,0,4.794H97.756a2.4,2.4,0,0,1-2.4-2.4Zm12.8,2.4H76.02a2.4,2.4,0,1,0,0,4.793h32.141a2.4,2.4,0,1,0,0-4.793Zm-10.4-9.587H64.99a2.4,2.4,0,0,0,0,4.793H97.756a2.4,2.4,0,1,0,0-4.793Zm10.452-16.152a2.4,2.4,0,0,1,2.4-2.4H95.766a2.4,2.4,0,1,1,0,4.794h14.842a2.4,2.4,0,0,1-2.4-2.4Zm11.148,2.4H87.209a2.4,2.4,0,0,0,0,4.8h32.147a2.4,2.4,0,0,0,0-4.8Zm6.506-9.588H93.094a2.4,2.4,0,1,0,0,4.793h32.769a2.4,2.4,0,0,0,0-4.793ZM51.424,94.263a2.4,2.4,0,0,1,2.4-2.4H38.978a2.4,2.4,0,1,1,0,4.795H53.825a2.4,2.4,0,0,1-2.4-2.4Zm3.254,2.4H30.428a2.4,2.4,0,1,0,0,4.793h24.25a2.4,2.4,0,1,0,0-4.793Zm6.5-9.593H36.309a2.4,2.4,0,1,0,0,4.8H61.182a2.4,2.4,0,1,0,0-4.8ZM55.933,54.351a2.4,2.4,0,0,0,2.4,2.4H43.488a2.4,2.4,0,0,0,0-4.8H58.334a2.4,2.4,0,0,0-2.4,2.4Zm22.079-2.4H42.305a2.4,2.4,0,1,1,0-4.794H78.012a2.4,2.4,0,1,1,0,4.794ZM65.691,61.543H40.818a2.4,2.4,0,0,1,0-4.795H65.691a2.4,2.4,0,1,1,0,4.8Zm47.843,44.2H81.389a2.4,2.4,0,1,0,0,4.8h32.146a2.4,2.4,0,0,0,0-4.8ZM54.313,68.569H22.167a2.4,2.4,0,1,0,0,4.792H54.313a2.4,2.4,0,0,0,0-4.792Zm48.135,29.024a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4ZM76.793,59.144a2.4,2.4,0,1,1-2.4-2.4,2.4,2.4,0,0,1,2.4,2.4Z",
    fill: "#fef8e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M81.389,105.746a2.4,2.4,0,1,0,0,4.8H97.12a38.317,38.317,0,0,0,6.429-4.8H81.389Zm22.625-40.158c0,.494-.019.979-.035,1.471h10.5a38.258,38.258,0,0,0-1.711-4.8h-2.159a2.391,2.391,0,0,1-.315-4.762,38.307,38.307,0,0,0-3.479-4.826h-5.033a38.258,38.258,0,0,1,2.233,12.915ZM45.036,98.055a38.7,38.7,0,0,0,2.443,3.4h4.316a39.019,39.019,0,0,1-6.759-3.4Zm47.783-.465a2.4,2.4,0,0,0-2.4-2.395h-.332a38.7,38.7,0,0,1-7.378,4.8h7.71A2.4,2.4,0,0,0,92.819,97.59ZM108.16,85.6H98.4A38.359,38.359,0,0,1,94.921,90.4h13.238a2.4,2.4,0,1,0,0-4.794Zm-5.712,11.989a2.4,2.4,0,1,0-2.4,2.4,2.4,2.4,0,0,0,2.4-2.4Z",
    fill: "#d9d8d7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M74.2,121.283H80.8V129.2H74.2ZM60.972,129.2H94.029v6.612H60.972Zm-7.851,6.612h48.758v6.609H53.121Z",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M77.5,123.05A45.549,45.549,0,0,1,52.264,39.582L54.2,42.5a42.049,42.049,0,1,0,58.3,58.3l2.912,1.941A45.478,45.478,0,0,1,77.5,123.05Z",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M20.688,144.834a8.683,8.683,0,0,1-6.4-2.262C10.488,138.768,11.6,130.618,17.5,119l1.783.906c-5.4,10.614-6.67,18.16-3.581,21.248,3.763,3.764,14.018,1.063,28.134-7.406,14.688-8.813,31.94-22.831,48.58-39.472,30.13-30.132,50.9-61.9,48.305-73.9l1.955-.422c2.768,12.812-17.774,44.663-48.846,75.736-16.752,16.753-34.142,30.878-48.965,39.772-7.8,4.68-17.324,9.368-24.182,9.368Z",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M140.712,16.147a6.962,6.962,0,0,0-2.122-1.439l-.809,1.83a4.984,4.984,0,0,1,1.517,1.023l1.414-1.414Zm-1.44,14.562c.476.626.933,1.267,1.389,1.908,1.961-5.178,2.7-9.5,2.02-12.659l-1.955.422c.559,2.591.025,6.108-1.454,10.329ZM134,15.919l-.049-2a22.391,22.391,0,0,0-4.454.614l.451,1.949A20.41,20.41,0,0,1,134,15.919ZM31.718,140.021c-7.815,3.259-13.436,3.714-16.011,1.138-2.512-2.512-2.139-7.972.991-15.633-.473-.6-.95-1.189-1.4-1.8-3.9,9.109-4.266,15.583-1,18.848a8.683,8.683,0,0,0,6.395,2.262c3.756,0,8.312-1.41,12.945-3.45q-.967-.669-1.915-1.364Zm93.9-123.253-.347-.976c-.195.069-.4.155-.6.229C124.983,16.266,125.3,16.517,125.614,16.768Z",
    fill: "#d9d8d7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.5737c5fbb3730ec25ca0a954e57d78e6.svg";
export { ForwardRef as ReactComponent };